export var notFoundError = function (message, url) { return ({
    kind: "NotFoundError",
    statusCode: 404,
    message: message,
    url: url,
}); };
export var isNotFoundError = function (pageError) { return pageError.kind === "NotFoundError"; };
export var internalServerError = function (message, url, refetch) { return ({
    kind: "InternalServerError",
    statusCode: 500,
    message: message,
    url: url,
    refetch: refetch,
}); };
export var isInternalServerError = function (pageError) { return pageError.kind === "InternalServerError"; };
